import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NOTIFICATION_PAGINATION_SIZE } from "../../../../config/constants";
import { useLazyGetAlertsQuery } from "../../../../lib/api/endpoints/settings/settingsEndpoints";
import {
  AlertsListState,
  alertsList as setAlertsState
} from "../../../../lib/redux/slices/alertsList";

export const useHandleNotificationQuery = () => {
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);

  const alerts = useSelector(
    (state: { alertsList: AlertsListState }) => state?.alertsList?.payload
  );

  const [getAlerts, { isFetching, data }] = useLazyGetAlertsQuery();
  const dispatch = useDispatch();

  useEffect(() => {
    getAlerts({
      page: currentPage,
      size: NOTIFICATION_PAGINATION_SIZE,
      status: "PENDING"
    })
      .unwrap()
      .then((res) => {
        dispatch(
          setAlertsState([...(alerts || []), ...(res?.payload?.content || [])])
        );
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, dispatch, getAlerts]);

  return {
    alerts,
    isLoadingMore,
    setIsLoadingMore,
    currentPage,
    setCurrentPage,
    data,
    isFetching,
    dispatch,
    setAlertsState
  };
};
